import React, { useState, useEffect } from "react";
import { ApiService } from "../services";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, ContentState, convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import GButton from "../gComponents/gButton";
import "../styledComponents/htmlEditorStyles.css";
import { useSnackbar } from "react-simple-snackbar";

export default function PrivacyPolicy() {
  const [policyData, setPolicyData] = useState({});
  const [openSnackbar] = useSnackbar();
  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );
  const getHtml = (editorState) => {
    return draftToHtml(convertToRaw(editorState.getCurrentContent()));
  };

  //convertFromRaw(editorState)
  const onEditorStateChange = (editorState) => {
    console.log(editorState);
    return setEditorState(editorState);
  };

  const onContentStateChange = (contentState) => {
    console.log("as HTML:", contentState);
    //this.setState({ contentState });
  };

  const getPrivacyPolicy = () => {
    ApiService({ method: "GET", route: "setting/identifier/privacy_policy" })
      .then((response) => {
        console.log(response);
        if (response.data.status_code === 1) {
          setPolicyData(response.data.data);
          setEditorState(
            EditorState.createWithContent(
              ContentState.createFromBlockArray(
                htmlToDraft(response.data.data.key_value).contentBlocks
              )
            )
          );
          console.log(editorState);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getPrivacyPolicy();
  }, []);

  const updatePolicy = () => {
    var text = getHtml(editorState);
    var hitUrl = "setting/" + policyData.id;
    console.log(hitUrl);

    var policyValue = {
      key_value: text,
    };
    ApiService({ method: "PUT", route: hitUrl, body: policyValue })
      .then((response) => {
        console.log(response);
        if (response.data.status_code === 1) {
          setEditorState(
            EditorState.createWithContent(
              ContentState.createFromBlockArray(
                htmlToDraft(response.data.data.key_value).contentBlocks
              )
            )
          );
          console.log(editorState);
        }
        openSnackbar(response.data.message);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div className="rightInnerView">
      <h2>Privacy Policy</h2>
      <div className="listPaper">
        <Editor
          editorState={editorState}
          initialContentState={editorState}
          editorContent={editorState}
          wrapperClassName="demo-wrapper"
          editorClassName="demo-editor"
          onContentStateChange={onContentStateChange}
          onEditorStateChange={onEditorStateChange}
        />
        <br />
        <GButton
          variant="condensed"
          children="Update"
          onClick={updatePolicy}
        ></GButton>
      </div>
    </div>
  );
}
